export default "/images/icon-poll-pinned.png?94eabe5bbf18e0f369280f31f653fcda";